import { Trans, useTranslation } from "react-i18next";
import { ExclamationIcon } from "@heroicons/react/outline";
// Self-serve subscription creation is disabled — Hilos is being phased
// out, so no new or restarted subscriptions should be created (WHAT-1274).
// import useHilosStore from "src/hooks/useHilosStore";
// import SubscriptionV1SelectPlan from "./SubscriptionV1SelectPlan";
// import SubscriptionV2SelectPlan from "./SubscriptionV2SelectPlan";

interface SubscriptionSelectPlanProps {
  currency: string;
}

export default function SubscriptionSelectPlan({
  currency,
}: SubscriptionSelectPlanProps) {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-6">
      <div className="rounded-md bg-red-50 p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <ExclamationIcon
              className="h-5 w-5 text-red-400"
              aria-hidden="true"
            />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-red-800">
              {t(
                "settings:account-inactive-notice.title",
                "Account is no longer active"
              )}
            </h3>
            <div className="mt-2 text-sm text-red-700">
              <Trans i18nKey="settings:account-inactive-notice.description">
                You can use{" "}
                <a
                  href="https://activecampaign.com"
                  target="_blank"
                  rel="noreferrer"
                  className="font-medium underline"
                >
                  ActiveCampaign
                </a>
                , or contact{" "}
                <a
                  href="mailto:hey@hilos.io"
                  className="font-medium underline"
                >
                  hey@hilos.io
                </a>
              </Trans>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // if (session?.account.pricing_model_version === "v2") {
  //   return <SubscriptionV2SelectPlan currency={currency} />;
  // } else {
  //   return <SubscriptionV1SelectPlan currency={currency} />;
  // }
}
